module.exports = __webpack_public_path__ + "img/claim.7c4b3471.png";